import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';
import './Header.css';

const Header = () => {
  const { user, isAuthenticated, isAdmin, logout } = useAuth();
  const { getItemCount } = useCart();
  const { t, language, toggleLanguage, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const savedLangRef = useRef(null);

  const isAdminPage = location.pathname.startsWith('/dashboard4');

  // Force English on admin pages, restore language when leaving
  useEffect(() => {
    if (isAdminPage) {
      if (savedLangRef.current === null) {
        savedLangRef.current = language;
      }
      if (language !== 'en') {
        setLanguage('en');
      }
    } else {
      if (savedLangRef.current !== null) {
        setLanguage(savedLangRef.current);
        savedLangRef.current = null;
      }
    }
  }, [isAdminPage]);

  const handleLogout = () => {
    logout();
    navigate('/');
    setShowMenu(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to={isAdmin ? "/dashboard4" : "/"} className="logo">
            <span className="logo-text">WebShop</span>
          </Link>

          <nav className="nav">
            <Link to="/" className="nav-link">{t('home')}</Link>
            <Link to="/products" className="nav-link">{t('products')}</Link>
          </nav>

          <div className="header-actions">
            {!isAdminPage && (
              <button onClick={toggleLanguage} className="lang-toggle">
                {language === 'ar' ? <strong>EN</strong> : 'عربي'}
              </button>
            )}

            <Link to="/cart" className="cart-link">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
              {getItemCount() > 0 && (
                <span className="cart-badge">{getItemCount()}</span>
              )}
            </Link>

            {isAuthenticated ? (
              <div className="user-menu">
                <button
                  className="user-menu-btn"
                  onClick={() => setShowMenu(!showMenu)}
                >
                  <span className="user-avatar">
                    {user.name.charAt(0).toUpperCase()}
                  </span>
                </button>

                {showMenu && (
                  <>
                    <div className="dropdown-overlay" onClick={() => setShowMenu(false)} />
                    <div className="dropdown-menu">
                      <div className="dropdown-header">
                        <span className="dropdown-name">{user.name}</span>
                        <span className="dropdown-email">{user.email}</span>
                      </div>
                      <div className="dropdown-divider"></div>
                      <Link to="/profile" onClick={() => setShowMenu(false)}>
                        {t('profile')}
                      </Link>
                      <Link to="/orders" onClick={() => setShowMenu(false)}>
                        {t('myOrders')}
                      </Link>
                      {isAdmin && (
                        <Link to="/dashboard4" onClick={() => setShowMenu(false)}>
                          {language === 'ar' ? 'الإدارة' : 'Admin'}
                        </Link>
                      )}
                      <div className="dropdown-divider"></div>
                      <button onClick={handleLogout}>{t('logout')}</button>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="auth-links">
                <Link to="/login" className="btn btn-outline btn-sm">{t('login')}</Link>
                <Link to="/register" className="btn btn-primary btn-sm">{t('signup')}</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
